import { compareAsc } from 'date-fns';

export function isPasswordValid(password) {
    let strength = 0;
    let lengthValid = false;

    // English uppercase characters (A through Z)
    if (/[A-Z]/.test(password)) {
        strength += 1;
    }

    // English lowercase characters (a through z)
    if (/[a-z]/.test(password)) {
        strength += 1;
    }

    // Base 10 digits (0 through 9)
    if (/[0-9]/.test(password)) {
        strength += 1;
    }

    // Non-alphabetic characters (for example, !, $, #, %)
    if (/[^A-Za-z0-9]/.test(password)) {
        strength += 1;
    }

    // check length
    if (password.length >= 6 && password.length <= 128) {
        lengthValid = true;
    }

    return strength >= 3 && lengthValid;
}

// eslint-disable-next-line max-len
const hostNamePattern = /(([a-zA-Z0-9]|[a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9])\.)+([A-Za-z0-9]|[A-Za-z0-9][A-Za-z0-9-]*[A-Za-z0-9])(\.?)/i;
const userPattern = /^[a-zA-Z0-9+.\-&_']+(?!.+)$/i;

export function isEmailValid(email) {
    const emailParts = email.split('@');

    if (emailParts.length !== 2) {
        return false;
    }

    const [username, hostname] = emailParts;

    if (!username || !userPattern.test(username)) {
        return false;
    }

    if (!hostname || !hostNamePattern.test(hostname)) {
        return false;
    }

    return true;
}

export function isPhoneNumberValid(input) {
    const pattern = /^[\d ]*$/;

    return pattern.test(input);
}

export function isDateValid(date, min, max) {
    const minDate = new Date(min);
    const maxDate = new Date(max);
    const selectedDate = new Date(date);

    if ((min && compareAsc(minDate, selectedDate) !== -1) || (max && compareAsc(selectedDate, maxDate) !== -1)) {
        return false;
    }

    return true;
}
